import { ActionFunctionArgs, Form, redirect } from "react-router-dom";
import toast from "react-hot-toast";
import { useState } from "react";
import { createApolloClient } from "../../../providers/ApolloClientFactory";
import { Input, TextArea } from "../../../components/inputs/Input";
import { FormLayout } from "../../../layout/FormLayout";

import { CREATE_BLOG_POST } from "./queries_mutations";
import BlogEditor from "../components/blogs/BlogEditor";

const client = createApolloClient();

export const blogpostCreateAction = async ({ request }: ActionFunctionArgs) => {
  const data = await request.formData();

  try {
    await client.mutate({
      mutation: CREATE_BLOG_POST,
      variables: {
        reference_label: data.get("title"),
        reference_value: data.get("content"),
        reference_links: data.get("links"),
        // reference_images: data.get("images"),
      },
    });
    toast.success("Blog Post Created Successfully");
    return redirect("/dashboard");
  } catch (error: any) {
    const errorType = error?.graphQLErrors?.[0]?.extensions?.code;
    const message = error?.graphQLErrors?.[0]?.message;
    if (errorType === "constraint-violation") {
      toast.error(message);
    } else {
      toast.error("Failed to create blog" + error);
    }
    return null;
  }
};

export const BlogPostCreate = () => {
  const [content, setContent] = useState<string>("");

  return (
    <Form
      action={`/blogpost/create`}
      method="post"
      encType="multipart/form-data"
    >
      <FormLayout>
        <div className="col-span-4 sm:col-span-3">
          <Input label="Title" type="text" name="title" />
        </div>
        <div className="col-span-6">
          <BlogEditor
            content={content}
            setContent={setContent}
            label="Content"
          />
          <Input type="hidden" name="content" value={content} />
        </div>
        {/*<div className="col-span-4 sm:col-span-3">*/}
        {/*  <Input label="Links" type="url" name="links" />*/}
        {/*</div>*/}
        {/* <div className="col-span-4 sm:col-span-3">
          <Input
            label="Images"
            type="file"
            name="image"
            accept="image/png, image/jpeg, image/gif"
            onChange={(file) => console.log(file)}
          />
        </div> */}
      </FormLayout>
    </Form>
  );
};
